// extracted by mini-css-extract-plugin
export default {"header":"Header_header__sBIHw","title":"Header_title__2Zt+6","nav":"Header_nav__bVv08","navBlock":"Header_navBlock__mBJiV","navTitles":"Header_navTitles__6JDdE"};